import { render, staticRenderFns } from "./AudienceDetails.vue?vue&type=template&id=6b24da25&scoped=true&"
import script from "./AudienceDetails.vue?vue&type=script&lang=js&"
export * from "./AudienceDetails.vue?vue&type=script&lang=js&"
import style0 from "./AudienceDetails.vue?vue&type=style&index=0&id=6b24da25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b24da25",
  null
  
)

export default component.exports